import React, { useState, useContext, useEffect } from "react";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import InterventoSADComponent from "./InterventoSADComponent";
import InterventoCentroFamigliaComponent from "./InterventoCentroFamigliaComponent";
import InterventoFamiglieAffidatarieComponent from "./InterventoFamiglieAffidatarieComponent";
import Repo from "../Utility/Repo";
import Loader from "../Components/Loader";
import MedicoInputComponent from "./MedicoInputComponent";
import moment from "moment";

function InterventiSocioAssistenzialiComponent({
  isExecutive,
  cartellaSociale,
  bandiAttivabili,
}) {
  const [loading, setLoading] = useState(false);
  const apiToken = useContext(TokenContext);
  const [showModalModify, setshowModalModify] = useState(false);
  const [fileB64, setFileB64] = useState(false);
  const [subId, setSubId] = useState();
  const [typeService, setTypeService] = useState(false);
  const [subfolder, setSubFolder] = useState(process.env.PUBLIC_URL);

  const [error, setError] = useState("");
  const [errorCheck, setErrorCheck] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  let filteredBandiAttivabili = [];

  if (Array.isArray(bandiAttivabili)) {
    filteredBandiAttivabili = bandiAttivabili.filter(
      (intervento) =>
        intervento.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        intervento.service.description
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
    );
    // Resto del codice
  }

  const [formData, setFormData] = useState();

  const resetFormFields = () => {
    setFormData({
      userId: cartellaSociale?.user?.id,
      announcementId: "",
      weeklyHour: 8,
      CentroFamigliaRequest: {},
      componentiNucleoFamiliareIds: [],
    });
    setError("");
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
    if (fileB64) {
      window.location.href =
        subfolder +
        "/lista_utenti/cartella_sociale/dettagli_iscrizione?id=" +
        subId;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleModify = (announcementId) => {
    setshowModalModify(true);
    setFormData({
      userId: cartellaSociale.user.id,
      announcementId: announcementId,
      weeklyHour: 8,
      CentroFamigliaRequest: {},
      componentiNucleoFamiliareIds: [],
    });
    bodyModify();
  };

  const handleSave = () => {
    const {
      userId,
      announcementId,
      weeklyHour,
      delegato,
      iban,
      CentroFamigliaRequest,
      otherServices,
      componentiNucleoFamiliareIds,
    } = formData;

    if (typeService === 5) {
      const requiredFields = [
        "progetto",
        "provvedimento",
        "intervento",
        "enteDisposzione",
        "titoloServizio",
      ];

      for (const field of requiredFields) {
        if (
          !CentroFamigliaRequest?.[field] ||
          CentroFamigliaRequest[field].trim() === ""
        ) {
          setErrorCheck(true);
          return;
        }
      }

      // Se "Altro" è selezionato, controlla anche il campo specifico
      if (
        CentroFamigliaRequest.enteDisposzione === "Altro" &&
        (!CentroFamigliaRequest.enteDisposzioneAltro ||
          CentroFamigliaRequest.enteDisposzioneAltro.trim() === "")
      ) {
        setErrorCheck(true);
        return;
      }
      if (
        CentroFamigliaRequest.titoloServizio === "Altro" &&
        (!CentroFamigliaRequest.titoloServizioAltro ||
          CentroFamigliaRequest.titoloServizioAltro.trim() === "")
      ) {
        setErrorCheck(true);
        return;
      }

      if (CentroFamigliaRequest.enteDisposzione === "Altro")
        CentroFamigliaRequest.enteDisposzione =
          CentroFamigliaRequest.enteDisposzioneAltro;

      if (CentroFamigliaRequest.titoloServizio === "Altro")
        CentroFamigliaRequest.titoloServizio =
          CentroFamigliaRequest.titoloServizioAltro;
    }

    const data = {
      userId,
      announcementId,
      weeklyHour,
      delegato,
      iban,
      CentroFamigliaRequest,
      otherServices,
      componentiNucleoFamiliareIds,
    };
    setLoading(true);

    Repo.postSubscribeUserFromOperator(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.data.documentoDaFirmare) {
          setFileB64(response.data.documentoDaFirmare);
          setSubId(response.data.subscriptionId);
        } else
          window.location.href =
            subfolder +
            "/lista_utenti/cartella_sociale/dettagli_iscrizione?id=" +
            response.data.subscriptionId;
        setLoading(false);
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
        setLoading(false);
      });
  };

  const bodyModify = () => {
    return (
      <>
        {!fileB64 ? (
          <>
            {typeService === 1 && !cartellaSociale?.medico ? (
              <MedicoInputComponent
                cartellaSocialeId={cartellaSociale?.id}
                medico={cartellaSociale?.medico}
              />
            ) : (
              <>
                <div className="row mb-lg-3">
                  Inserisci un intervento Socio Assistenziale per l'assistito{" "}
                  <strong className="ml-1">
                    {cartellaSociale?.user?.firstName}{" "}
                    {cartellaSociale?.user?.lastName}
                  </strong>
                </div>
                {typeService === 1 && (
                  <>
                    <div className="row justify-content-center">
                      <div
                        className="alert alert-warning text-center col-12"
                        role="alert"
                      >
                        Prima di procedere assicurarsi che <b>medico curante</b>{" "}
                        ed
                        <b> ISEE </b> siano corretti
                      </div>
                    </div>
                    <InterventoSADComponent
                      setFormData={setFormData}
                      formData={formData}
                    />
                  </>
                )}
                {typeService === 5 && (
                  <InterventoCentroFamigliaComponent
                    setFormData={setFormData}
                    formData={formData}
                    errorCheck={errorCheck}
                  />
                )}
                <div className="row">
                  <div className="col-lg-12">
                    {typeService === 6 && (
                      <InterventoFamiglieAffidatarieComponent
                        handleChange={handleChange}
                        formData={formData}
                        iban={cartellaSociale?.iban}
                        componenteNucleoFamiliare={cartellaSociale?.componenteNucleoFamiliare.filter(
                          (c) => {
                            const eta = moment().diff(
                              moment(c.dataNascita, "DD-MM-YYYY"),
                              "years"
                            );
                            return eta < 18;
                          }
                        )}
                      />
                    )}
                    {error && (
                      <div className="alert alert-danger mt-2" role="alert">
                        <b>Attenzione:</b> {error}.
                      </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-primary btn-salva"
                        type="button"
                        onClick={() =>
                          typeService === 6 &&
                          formData?.componentiNucleoFamiliareIds?.length === 0
                            ? setError("Selezionare almeno un minore")
                            : handleSave()
                        }
                      >
                        Iscrivi
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <object
              className="mt-5"
              width="100%"
              height="900"
              data={
                fileB64 ? `data:application/pdf;base64,${fileB64}` : undefined
              }
              type="application/pdf"
            ></object>
          </>
        )}
      </>
    );
  };

  return (
    <div className="col-lg-12 no_print">
      <div className="card-body" key="interventiSocioAssistenziali">
        <div className="row max-height-div">
          <div className="col-lg-9">
            <h5>Aggiungi nuovo intervento Socio Assistenziale</h5>
          </div>
          <div className="col-lg-3">
            <input
              type="text"
              placeholder="Cerca"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-lg-1 d-flex justify-content-end"></div>
        </div>
        {filteredBandiAttivabili.length > 0 ? (
          filteredBandiAttivabili.map((intervento) => (
            <div key={intervento.id}>
              <div className="d-flex justify-content-between">
                <div>
                  <p>
                    {" "}
                    {intervento.name} <strong> {intervento.state} </strong>
                  </p>
                </div>
                <div>
                  {isExecutive && intervento.service.tipoServizio !== 2 ? (
                    <button
                      className="btn btn-outline-secondary border p-1"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Ruolo operatore non abilitato"
                      disabled
                    >
                      <svg className="icon icon-secondary">
                        <use href={`${iconSprite}#it-plus`} />
                      </svg>
                      &nbsp; Aggiungi&nbsp;
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-primary p-1"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Modifica"
                      disabled={
                        isExecutive && intervento.service.tipoServizio !== 2
                      }
                      onClick={() => (
                        handleModify(intervento.id),
                        setTypeService(intervento.service.tipoServizio)
                      )}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-plus`} />
                      </svg>
                      &nbsp; Aggiungi&nbsp;
                    </button>
                  )}
                </div>
              </div>

              <p>{intervento.service.description}</p>

              {/* Altri dettagli dell'intervento */}

              <hr />
            </div>
          ))
        ) : (
          <h2>Non ci sono interventi socio assistenziali disponibili.</h2>
        )}
      </div>

      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Iscrivi"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
      {loading && <Loader></Loader>}
    </div>
  );
}

export default InterventiSocioAssistenzialiComponent;
